import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import CompanyMenuLinks from './CompanyMenuLinks.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CompanyMenu',
    setup(__props, { expose }) {
        expose();
        const visibleLeft = ref(false);
        const __returned__ = { visibleLeft, get Button() { return Button; }, get Sidebar() { return Sidebar; }, CompanyMenuLinks };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
